import React, { useState } from "react";

export default function InputField({
  id,
  name,
  type,
  value,
  onChange,
  placeholder,
  required,
}) {
  return (
    <div>
      <input
        type={type}
        id={id}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
      />
    </div>
  );
}

export function SelectField({ id, name, value, onChange, options, required }) {
  return (
    <div>
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className="mt-1 block w-full pl-2 h-8 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
        required={required}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export function FileInputField({
  label,
  id,
  name,
  accept,
  onChange,
  required,
  icon: Icon,
  iconColor,
}) {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    onChange(event);
  };

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}:
      </label>
      <div className="flex items-center mt-1">
        <label
          htmlFor={id}
          className="cursor-pointer bg-white border border-gray-300 rounded-md py-1 px-3 flex items-center justify-center hover:bg-gray-50"
        >
          {selectedFile ? (
            <>
              {Icon && <Icon className={`mr-2 text-${iconColor}`} />}
              {selectedFile.name}
            </>
          ) : (
            <>
              {Icon && <Icon className={`mr-2 text-${iconColor}`} />}
              Seleccionar archivo
            </>
          )}
          <input
            type="file"
            id={id}
            name={name}
            accept={accept}
            onChange={handleFileChange}
            className="sr-only"
            required={required}
          />
        </label>
      </div>
    </div>
  );
}
export function DateInputField({ label, id, name, value, onChange, required }) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}:
      </label>
      <input
        type="date"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className="mt-1 block w-full pl-2 h-8 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
      />
    </div>
  );
}
